import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { useLoader } from "../../utils/LoaderUtils";
import RowsPerPage from "../../components/partials/RowsPerPage";
import Pagination from "../../components/partials/Pagination";
import WishlistAPI from "../../api/promo/wishlistApi";

function User() {
  const { id } = useParams();
  const [items, setItems] = useState([]);
  const [product, setProduct] = useState([]);
  const [pagination, setPagination] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  const { showLoader, hideLoader } = useLoader();

  const query = useMemo(
    () => ({
      page: Number(searchParams.get("page")) || 1,
      limit: Number(searchParams.get("limit")) || 10,
      status: searchParams.get("status") || "",
      search: searchParams.get("search") || "",
    }),
    [searchParams],
  );

  const fetchCustomers = useCallback(async () => {
    showLoader();

    try {
      const res = await WishlistAPI.getDetails(id, query);

      if (res.code === 200) {
        const { customers, pagination, product } = res.data;

        setItems(customers);
        setProduct(product);
        setPagination(pagination);
      }
    } catch (err) {
    } finally {
      hideLoader();
    }
  }, [query, showLoader, hideLoader, id]);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  const updateFilter = useCallback((key, value) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      if (value) params.set(key, value);
      else params.delete(key);
      return params;
    });
  }, [setSearchParams]);

  const startIndex = useMemo(() => {
    return (query.page - 1) * query.limit;
  }, [query]);

  return (
    <div className="content">
      <div className="page-header">
        <div className="add-item d-flex">
          <div className="page-title">
            <h4>All Customers for {product?.title}</h4>
            <h6>Keep track and manage your customer database efficiently</h6>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body p-0">
          <div className="row">
            <div className="col-md-12">
              <div className="countablepagination p-2">
                <p>
                  Showing {(pagination.page - 1) * pagination.limit + 1} to{" "}
                  {Math.min(
                    pagination.page * pagination.limit,
                    pagination.total,
                  )}{" "}
                  of {pagination.total} results
                </p>
              </div>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table">
              <thead className="thead-light">
                <tr>
                  <th>S. No. </th>
                  <th>Customer Details</th>
                  <th>Email</th>
                  <th>Phone</th>
                </tr>
              </thead>
              <tbody>
                {items.length > 0 ? (
                  items.map((item, index) => (
                    <tr key={item._id}>
                      <td>{startIndex + index + 1}</td>

                      <td>
                        <Link to={`/customer/details/${item.user?._id}`}>
                          {item?.user?.name}
                        </Link>
                      </td>

                      <td>
                        {item?.user?.email && (
                          <div>
                            <a href={`mailto:${item?.user?.email}`}>
                              {item?.user?.email}
                            </a>
                          </div>
                        )}
                      </td>
                      <td>
                        {item?.user?.phone && (
                          <div>
                            <a href={`tel:${item?.user?.phone}`}>
                              +91-{item?.user?.phone}
                            </a>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center p-4 text-muted">
                      No customers found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="row">
            <RowsPerPage
              value={searchParams.get("limit") || "10"}
              onChange={(val) => updateFilter("limit", val)}
            />

            <Pagination pagination={pagination} updateFilter={updateFilter} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default User;
